import { useLang } from "@/context/LanguageContext";
import { LANGS } from "@/i18n";

const Footer = () => {
  const { t, lang, setLang } = useLang();
  return (
    <footer className="bg-primary text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 pb-10 pt-20 lg:px-10">
        <div className="grid grid-cols-1 gap-10 border-b border-white/10 pb-12 lg:grid-cols-12">
          <div className="lg:col-span-6">
            <p className="max-w-md text-lg leading-relaxed text-white/70">{t.footer.tagline}</p>
            <div className="mt-6 flex gap-2">
              {LANGS.map((l) => (
                <button key={l.code} onClick={() => setLang(l.code)}
                  className={`rounded-full border px-3 py-1 text-sm transition-colors ${lang === l.code ? "border-accent bg-accent text-white" : "border-white/20 text-white/70 hover:border-accent"}`}>
                  {l.label}
                </button>
              ))}
            </div>
          </div>
          <div className="lg:col-span-6 lg:text-right">
            <a href="#top" className="font-heading text-2xl font-semibold text-white">aponiqo@outlook.com</a>
            <p className="mt-2 text-white/50">België · Nederland · Luxemburg</p>
          </div>
        </div>
        <div className="flex flex-col items-start justify-between gap-4 pt-8 sm:flex-row sm:items-center">
          <div className="flex items-center">
            <img src="/logo_aponiqo_light.png" alt="aponiqo" className="h-14 w-auto sm:h-16 lg:h-20" />
          </div>
          <div className="flex flex-col items-start gap-1 sm:items-end">
            <p className="font-heading text-sm font-semibold text-white/80">APRAD BV</p>
            <p className="text-sm text-white/50">© {new Date().getFullYear()} aponiqo. {t.footer.rights}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
